<p-fieldset [toggleable]="to.toggleable" [collapsed]="to.collapsed" [styleClass]="to.styleClass">
  <ng-template pTemplate="header">
    <span [class]="isInvalid ? 'p-error' : ''">
      {{ to.label }} <i *ngIf="to.tooltip" class="pi pi-info-circle ml-2" [pTooltip]="to.tooltip"></i>
    </span>
  </ng-template>

  <formly-group [field]="$any(field)"></formly-group>
</p-fieldset>
